





































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Info from '@/views/AiiTasks/Info.vue'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import ImageList from '@/views/AiiTasks/ImageList.vue'
import { setViewer } from '@/utils/util'

let reasonViewer: any = ''
let historyViewer: any = ''

@Component({
	components: {
		Info,
		InfoRow,
		ImageList,
	},
})
export default class AddTask extends Vue {
	@Prop()
	public reason!: any

	@Prop()
	public history!: any

	@Prop()
	public order!: any

	private getCancelOrder(index: any) {
		return Math.ceil(index / 2)
	}

	@Watch('reason', { immediate: true })
	private onReasonChange() {
		if (this.reason) {
			this.$nextTick(() => {
				if (this.reason) {
					const dom = document.querySelector('#cancel-images')
					if (dom) {
						reasonViewer = setViewer(dom, reasonViewer)
					}
				}
			})
		}
	}

	@Watch('history', { immediate: true })
	private onHistoryChange() {
		if (this.history) {
			this.$nextTick(() => {
				if (this.history) {
					const dom = document.querySelector('.cancel-history')
					if (dom) {
						historyViewer = setViewer(dom, historyViewer)
					}
				}
			})
		}
	}
}
